import React, {PropTypes} from 'react';
import {__} from '../../../server/lib/i18n-2/browserHelper'

const FilterContainer = (props) => (
  <div className="filters-component">
    <div className="filters-section no-margin">
      <div className="container">
        <div className="row section">
          <div className="col-sm-12 item">
            <div className="centered content">
              <div className="input-group-basic">
                {props.searchField}
                <div className="special-header closer" onClick={() => props.handleClose()}>
                  {__('ROZŠÍŘENÉ HLEDÁNí')}
                  <i className={'after-text fa '  + (props.closed && 'fa-caret-down' || 'fa-caret-up')} aria-hidden="true"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={'filters-section closeable ' + (props.closed && 'closed' || '')}>
      <div className="container">
        {props.children}
      </div>
    </div>
    <div className="line"/></div>
)


export default FilterContainer



// WEBPACK FOOTER //
// ./src/browser/components/stateless/FilterContainer.react.js